export default __webpack_public_path__ + "static/image-16-b86a8e0313c50c7f72ba858056dff7e1.jpg";